/*
 * HomePage
 */

import React from 'react';

// Others
import { Switch, Route, useRouteMatch } from 'react-router-dom';

// Components & Others
import NotFound from '../../NotFoundPage';
import FilesList from '../../../components/Models/EmployeeFiles/FilesList';
import ProcessForm from 'src/components/Models/EmployeeFiles/Form';
import ProcessFormMultipleFiles from 'src/components/Models/EmployeeFiles/FormMultipleUpload';

function EmployeeFilesPage() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path} component={FilesList} />
      <Route path={`${path}/crear`} component={ProcessForm} />
      <Route
        path={`${path}/crearMultiple`}
        component={ProcessFormMultipleFiles}
      />
      <Route exact path={path} component={NotFound} />
    </Switch>
  );
}

EmployeeFilesPage.propTypes = {};

export default EmployeeFilesPage;
